import { computed, inject, Injectable } from '@angular/core';
import { CurrentUserService } from './current-user.service';
import { LimitedFeatures } from '../models/pack.models';
import { ContactModalService } from './contact-modal.service';

@Injectable({
  providedIn: 'root',
})
export class PackLimitationsService {
  private currentUserService = inject(CurrentUserService);
  private contactModalService = inject(ContactModalService);
  private pack = this.currentUserService.pack;
  canExportPDF = computed(() => {
    return this.pack()?.exportPDF;
  });
  canExportExcel = computed(() => {
    return this.pack()?.exportExcel;
  });

  tripLimit = computed(() => {
    return this.pack()?.tripLimit ?? 0;
  });
  currentNumberOfTrips = computed(() => {
    return this.currentUserService.currentUser()?.company?._count?.trips ?? 0;
  });
  canCreateTrip = computed(() => {
    return this.currentNumberOfTrips() < this.tripLimit();
  });
  canUseBulkUpload = computed(() => {
    return this.pack()?.bulkUpload;
  });
  // Max files allowed per bulk upload, as defined by the pack (0 = disabled)
  bulkUploadFileLimit = computed(() => {
    return this.pack()?.bulkUpload ?? 0;
  });
  remainingTrips = computed(() => {
    return this.tripLimit() - this.currentNumberOfTrips();
  });
  canFilterClient = computed(() => {
    return this.pack()?.clientFilter;
  });
  userLimit = computed(() => {
    return this.pack()?.userLimit ?? 0;
  });
  canCreateUser = computed(() => {
    return this.currentNumberOfUsers() < this.userLimit();
  });
  currentNumberOfUsers = computed(() => {
    return this.currentUserService.currentUser()?.company?._count?.users ?? 0;
  });

  remainingUsers = computed(
    () => this.userLimit() - this.currentNumberOfUsers(),
  );
  canDisplayComparisonGraph = computed(() => {
    return this.pack()?.comparisonGraph;
  });

  openModal(type?: LimitedFeatures) {
    this.contactModalService.open(type);
  }

  isDiscovery = computed(() => {
    return this.pack()?.code === 'FREE';
  });
}
